<template>
    <div id="marketplace-products-listing" class="wspro-product-listing">
        <div id="worksends-page-header" class="tw-grid tw-mt-2 tw-grid-cols-2">
            <div>
                <div class="breadcrumbs" id="breadcrumbs">
                    <span class="breadcrumb-link">Marketplace</span>  &gt;
                    <router-link class="breadcrumb-link" to="/marketplace/physical">Physical Gifts Selection</router-link>
                </div>
                <h3 style="float: left;">Marketplace <span>Physical Gifts Selection</span></h3>
            </div>
            <div class="ws-filters tw-flex tw-justify-end" :class="(showTutorial(0)) ? 'in-tutorial': ''">
                <div class="ws-filter ws-filter-select">
                    <label>Gift Category</label>
                    <select v-model="pageParams.filters.type.val" name="marketplace-product-type" @change="setFilter">
                        <option value="null">All Categories</option>
                        <option v-for="term in typeTerms" v-bind:value="term.value">{{ term.name }}</option>
                    </select>
                </div>
                <div class="ws-filter ws-filter-select">
                    <label>Gift Occasion</label>
                    <select v-model="pageParams.filters.occasion.val" name="marketplace-product-occasion" @change="setFilter">
                        <option value="null">All Occasions</option>
                        <option v-for="term in occasionTerms" v-bind:value="term.value">{{ term.name }}</option>
                    </select>
                </div>
                <div class="ws-filter ws-filter-select">
                    <label>Dietary Restrictions</label>
                    <select v-model="pageParams.filters.diet.val" name="marketplace-product-diet" @change="setFilter">
                        <option value="null">No Restrictions</option>
                        <option v-for="term in dietTerms" v-bind:value="term.value">{{ term.name }}</option>
                    </select>
                </div>
                <div class="ws-filter ws-filter-select">
                    <label>Gift Price</label>
                    <select v-model="pageParams.filters.price.val" name="marketplace-product-price" @change="setFilter">
                        <option value="null">Any Price</option>
                        <option value="0-30">Below £30</option>
                        <option value="30-50">£30 to £50</option>
                        <option value="50-9999">£50 and more</option>
                    </select>
                </div>
                <tutorial-tooltip v-if="showTutorial(0)" location="marketplace" tooltip="gift-options"></tutorial-tooltip>
            </div>
        </div>
        <div class="wspro-product-list">
            <div v-for="(item, index) in index.data" :key="item.id" class="wspro-product-list-item" ref="listProducts">
                <product-list-item location="marketplace" :item="item" :index="index" @open-detail-modal="openDetailModal" @open-send-modal="openSendModal" @open-link-modal="openLinkModal"></product-list-item>
            </div>
        </div>

        <div class="note" v-if="index.meta.total == 0 && !$wait.any"><b>There are no available Marketplace products that match your filters.</b><br>We advise you to try different filter options.</div>
        <ws-table-meta v-if="!$wait.any" :meta="index.meta" format="grid" :sum="'% Bookblock HUB Marketplace products'+((pageParams.filters.type.val || pageParams.filters.occasion.val || pageParams.filters.price.val)?' that match your filters':'')+'.'"></ws-table-meta>

        <marketplace-product-modal v-if="modals.marketplaceProductModal" :product-id="productId" @open-send-modal="openSendModal" @open-link-modal="openLinkModal"></marketplace-product-modal>
        <gift-registration-modal v-if="modals.giftRegistrationModal" :product-id="productId" platform="marketplace" :fetch-item="false" @created="onDirectSend" :type="'create'"></gift-registration-modal>
        <gift-invite-modal v-if="modals.giftInviteModal" :product-id="productId" :registration-link-details="registrationLinkDetails" platform="marketplace" @generated="onLinkGenerate"></gift-invite-modal>
        <marketplace-tutorial-modal v-if="modals.marketplaceTutorialModal"></marketplace-tutorial-modal>
        <div class="refresher" v-if="!modals.marketplaceTutorialModal && !tutorial.enabled">
            <span class="heading">Need a refresher?</span>
            <span class="ws-button" @click.stop="startTutorial">Start 2-min Tutorial</span>
			<span class="mobile" @click.stop="startTutorial"></span>
        </div>
    </div>
</template>

<script>
import ProductListItem from "@/components/ProductListItem";
import MarketplaceProductModal from "@/pages/marketplace/MarketplaceProductModal";
import GiftRegistrationModal from '@/components/modals/GiftRegistrationModal';
import GiftInviteModal from '@/components/modals/GiftInviteModal';
import MarketplaceTutorialModal from '@/components/modals/MarketplaceTutorialModal';
import TutorialTooltip from "@/components/modals/TutorialTooltip";

export default {
    name: "MarketplacePhysicalGiftsIndex",
    components: { ProductListItem, MarketplaceProductModal, GiftRegistrationModal, GiftInviteModal, MarketplaceTutorialModal, TutorialTooltip },
    data() {
        return {
            pageParams: {
                pageOptions: {page:1, sortBy:[], sortDesc:[], itemsPerPage: 24},
                search: {val: ""},
                filters: {
                    type: { val: null, type: 'single' },
                    occasion: { val: null, type: 'single' },
                    diet: { val: null, type: 'single' },
                    price: { val: null, type: 'single' },
                }
            },
            errors: {},
            productId: 0,
        }
    },
    methods: {
        async getPage(params) {
			await this.getPageHandler({
                waitName: 'marketplace.physical.index',
                action: 'fetchMarketplacePhysicalProducts', // vuex action
                pageParams: this.pageParams,
                isInit: params ? params.init : false, // parse from url query params
                pushRoute: true, // push pagination params and search q to route
                resetPagination: params ? params.resetPagination : false, // new search input -> need to reset page & sorting
                routeParams: {teamId: parseInt(this.team.id)},
            });
        },
        async fetchData() {
            await this.dispatchWaitAndNotify('fetchTermsInCategory', {taxonomy:['marketplace-product-type','marketplace-product-occasion','marketplace-product-diet'],format:'filters'}, false, true);
        },
        async setFilter() {
			console.log(JSON.stringify(this.pageParams.filters.type)); 
            await this.getPage();
			console.log(JSON.stringify(this.pageParams.filters.type));
        },
        openDetailModal(id) {
            this.productId = id;
            this.modals.marketplaceProductModal = true;
        },
        openSendModal(id) {
            this.productId = id;
            this.modals.giftRegistrationModal = true;
        },
        openLinkModal(id) {
            this.productId = id;
            this.modals.giftInviteModal = true;
        },
		openTutorialModal() {
            this.$store.commit('openTutorialModal');
		},
        startTutorial() {
			this.$store.dispatch('tutorials/startTutorial', 'marketplace');

            document.getElementById('worksends-main').scrollTo({ top: 0, behavior: 'smooth' });

            let ttlCookie = this.$cookies.get('ws_tutorial');
			if (ttlCookie !== null && 'step' in ttlCookie) this.$store.commit('tutorials/setStep', { tutorial: 'marketplace', step: ttlCookie.step });
			if (
				window.innerWidth <= this.$store.state.sidebarBP
				&& this.tutorial.steps[this.tutorial.currentStep].inMenu === true
				&& !this.sidebarShown
			) {
				this.toggleSidebar();
			}
		},
        showTutorial(i) {
            return (this.tutorial.enabled && (i === this.tutorial.currentStep));
        },
        onLinkGenerate() {

        },
        onDirectSend() {
            this.modals.giftRegistrationModal = false;
       },
        toggleSidebar() {
			this.$root.$emit('bv::toggle::collapse', 'worksends-left-sidebar-toggle');
        }
    },
    mounted() {
        this.pageParams.pageOptions.itemsPerPage = this.itemsPerPageCookie(this.$options.name,24);
		this.getPage({init:true});
        this.fetchData();
		if (
			(this.team.plan !== 'pro' || this.demo.isDemo)
			&& this.$cookies.get('ws_tutorial') === null
			&& window.innerWidth > 768) 
		{
			this.openTutorialModal();
			this.$cookies.set('ws_tutorial', { status: 'started' });
		}
    },
    computed: {
        team() {
			return this.$store.state.team.detail;
		},
        index() {
            return this.$store.state.product.index;
        },
        item() {
            return this.$store.state.product.detail;
        },
        modals() {
            return this.$store.state.modals;
        },
		tutorial() {
            return this.$store.state.tutorials.marketplace;
        },
        typeTerms() {
            return this.$store.state.term.terms['marketplace-product-type'];
        },
        occasionTerms() {
            return this.$store.state.term.terms['marketplace-product-occasion'];
        },
        dietTerms() {
            return this.$store.state.term.terms['marketplace-product-diet'];
        },
		sidebarShown() {
			return this.$store.state.sidebarShown;
		},
        demo() {
            return this.$store.state.demo;
        }
    },
    watch: {
        'pageParams.pageOptions': {
            handler (newVal, oldVal) {
                if (oldVal != null) { // we need to load initial data based on url query instead
                    //this.getPage();
                }
            },
            deep: true,
        },
        'team.id': {
            handler (newVal) {
                if (newVal != null) {
                    this.getPage({init:true});
                }
            },
        },
		'tutorial.enabled'(val) {
			if (val === false) {
				document.body.classList.remove('ws-modal', 'ws-tutorial');
				document.documentElement.classList.remove('no-scroll-modal');
			}
		}
    },
}
</script>

<style scoped>

</style>
